module.exports = __webpack_public_path__ + "static/media/Push-Preview-Frame.7fd431da.svg";